export const SET_USER_INFO = "profile/SET_USER_INFO"
